import React from 'react'
import LoginSupabaseContainer from '../containers/LoginSupabase/LoginSupabase.container'
import LoginLayout from '../components/Layouts/LoginLayout'

const LoginSupabase = () => {
  return (
    <LoginLayout>
      <LoginSupabaseContainer />
    </LoginLayout>
  )
}

export default LoginSupabase
